import styles from './LoadingSpinner.module.css';

const LoadingSpinner = ({ message = "Loading..." }) => {
  return (
    <div className={styles.spinnerContainer}>
      <div className={styles.spinner}></div>
      <p className={styles.message}>{message}</p>
    </div>
  );
};

export default LoadingSpinner;
